import {defineMessages} from 'react-intl';

export default defineMessages({
    defaultPlaceholder: {
        id: 'textField.defaultPlaceholder'
    }
});
